import { getStorage, ref, uploadBytes } from "firebase/storage";
import { useCallback } from "react";
import * as uuid from "uuid";
import { firebaseApp } from "~/firebaseApp";
import { useFirebaseUser } from "./useFirebaseUser.shared";

const storage = getStorage(firebaseApp);

export const useFirebaseImageUpload = () => {
  const { user } = useFirebaseUser();

  return useCallback(
    async (file: File) => {
      if (file.size / 1024 / 1024 > 5) {
        throw new Error("File size is too large. Maximum is 5MB");
      }

      const extension = file.name.split(".").pop();
      const imagePath = `users/${user?.firebaseUser.uid}/${uuid.v4()}.${extension}`;
      const imageRef = ref(storage, imagePath);

      await uploadBytes(imageRef, file);

      return `${import.meta.env.VITE_IMG_URL}/${imagePath}`;
    },
    [user?.firebaseUser.uid],
  );
};
